import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('userData');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    const syncUserFromSession = async () => {
      const { data } = await supabase.auth.getSession();
      const sessionUser = data?.session?.user;

      if (!sessionUser) {
        return;
      }

      const metadata = sessionUser.user_metadata || {};
      const mergedUser = {
        nome: metadata.firstName || metadata.nome || '',
        cognome: metadata.lastName || metadata.cognome || '',
        email: sessionUser.email || metadata.email || '',
        telefono: metadata.phone || metadata.telefono || '',
        loyalty_points: metadata.loyalty_points ?? 0,
      };

      localStorage.setItem('userData', JSON.stringify(mergedUser));
      setUser(mergedUser);
    };

    syncUserFromSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      const sessionUser = session?.user;

      if (!sessionUser) {
        localStorage.removeItem('userData');
        setUser(null);
        return;
      }

      const metadata = sessionUser.user_metadata || {};
      const mergedUser = {
        nome: metadata.firstName || metadata.nome || '',
        cognome: metadata.lastName || metadata.cognome || '',
        email: sessionUser.email || metadata.email || '',
        telefono: metadata.phone || metadata.telefono || '',
        loyalty_points: metadata.loyalty_points ?? 0,
      };

      localStorage.setItem('userData', JSON.stringify(mergedUser));
      setUser(mergedUser);
    });

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  const login = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('userData');
    setUser(null);
  };

  const value = { user, login, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}